export const pduPruReadableNames = [
   { key: '001', value: 'IPS Älmhult' },
   { key: '004', value: 'TSO Dortmund' },
   { key: '008', value: 'TSO Paris' },
   { key: '010', value: 'TSO Milano' },
   { key: '011', value: 'TSO Bangkok' },
   { key: '012', value: 'TSO Shenzen' },
   { key: '013', value: 'TSO New Delhi' },
   { key: '014', value: 'TSO Taichung' },
   { key: '021', value: 'TSO Warsaw' },
   { key: '022', value: 'TSO BUCHAREST' },
   { key: '024', value: 'TSO PRAG' },
   { key: '025', value: 'TSO MOSCOW' },
   { key: '027', value: 'TSO SOFIA' },
   { key: '028', value: 'TSO ISTANBUL' },
   { key: '029', value: 'TSO KUALA LUMPUR' },
   { key: '030', value: 'TSO QINGDAO' },
   { key: '031', value: 'TSO Jakarta' },
   { key: '033', value: 'TSO KARACHI' },
   { key: '037', value: 'TSO SHANGHAI' },
   { key: '041', value: 'TSO Ho Chi Minh' },
   { key: '051', value: 'WUHAN' },
   { key: '063', value: 'TSO HAARLEM' },
   { key: '064', value: 'TSO KIEV' },
   { key: '068', value: 'TSO BRAZIL' },
   { key: '342', value: 'DEVC SEA (Ho Chi Min City)' },
   { key: '352', value: 'PDC Poland' },
   { key: 'CHN', value: 'DEVC EA (SHANGHAI)' },
   { key: 'FAM', value: 'FAMILY' },
   { key: 'FRR', value: 'FREE RANGE' },
   { key: 'IFS', value: 'IFS' },
   { key: 'IND', value: 'DEVC SA (DELHI)' },
   { key: 'IOS', value: 'IOS' },
   { key: 'IRE', value: 'IRE' },
   { key: 'ISH', value: 'IKEA HOME SMART' },
   { key: 'PHIL', value: 'PDU PHILADELPHIA' },
   { key: 'POL', value: 'DEVC CE (WARSAW)' },
   { key: 'SHAN', value: 'PDC SHANGHAI' },
   { key: 'VIET', value: 'DEVC SEA (HO CHI MIN CITY)' },
] as const;
